import TYPES from './actionTypes'
import db from '../firebase'
import makeGoalsCompatible from 'utils/makeGoalsCompatible'
import makeProfileCompatible from 'utils/makeProfileCompatible'
import progressUpdateAge from 'utils/progressUpdateAge'
import progressUpdateGoals from 'utils/progressUpdateGoals'
import progressUpdateSaved from 'utils/progressUpdateSaved'

export const createGoal = (params, id) => ({
  type: TYPES.CREATE_GOAL,
  payload: {
    [id]: {
      ...params,
      id,
    },
  },
})

export const setActiveGoal = id => ({
  type: TYPES.SET_ACTIVE_GOAL,
  payload: id,
})

export const deleteGoal = id => ({
  type: TYPES.DELETE_GOAL,
  payload: id,
})

export const deleteAllGoals = () => ({
  type: TYPES.DELETE_ALL_GOALS,
})

export const setGoalProp = (id, key, value) => ({
  type: TYPES.SET_GOAL_PROP,
  payload: { id, key, value },
})

export const setPlanProp = (key, value) => ({
  type: TYPES.SET_PLAN_PROP,
  payload: { key, value },
})

export const loadProfile = profile => ({
  type: TYPES.LOAD_PROFILE,
  payload: { profile },
})

export const loadGoals = goals => ({
  type: TYPES.LOAD_GOALS,
  payload: { goals },
})

export const setGlobalSetting = (setting, key, value) => ({
  type: TYPES.SET_GLOBAL_SETTING,
  payload: { setting, key, value },
})

export const setUserSetting = (key, value) => ({
  type: TYPES.SET_USER_SETTING,
  payload: { key, value },
})

export const loadSharedPlan = id => dispatch =>
  db
    .doc(`shared-plans/${id}`)
    .get()
    .then(doc => {
      const { profile, goals, globalSettings } = doc.data()
      dispatch({
        type: TYPES.DELETE_ALL_GOALS,
      })
      dispatch({
        type: TYPES.LOAD_PROFILE,
        payload: { profile: makeProfileCompatible(profile) },
      })
      dispatch({
        type: TYPES.LOAD_GOALS,
        payload: { goals: makeGoalsCompatible(goals) },
      })
      if (globalSettings) {
        dispatch({
          type: TYPES.LOAD_GLOBAL_SETTINGS,
          payload: { globalSettings },
        })
      }
    })

export const loadSavedPlan = id => dispatch => {
  fetch(
    `https://backoffice.capitalmind.in/api/goals/plans/json/archives/${id}`,
    {
      credentials: 'include',
    }
  )
    .then(response => {
      if (response.ok) {
        return response.json()
      } else {
        throw Error('Failed to fetch data')
      }
    })
    .then(({ results }) => {
      dispatch({
        type: TYPES.DELETE_ALL_GOALS,
      })
      dispatch({
        type: TYPES.LOAD_PROFILE,
        payload: {
          profile: progressUpdateAge(results.plan_json.profile, results.age),
        },
      })
      dispatch({
        type: TYPES.SET_PLAN_PROP,
        payload: {
          key: 'savings',
          value: progressUpdateSaved(results.goal_actuals_amount),
        },
      })
      dispatch({
        type: TYPES.LOAD_GOALS,
        payload: {
          goals: makeGoalsCompatible(
            progressUpdateGoals(
              results.plan_json.goals,
              results.goal_actuals_amount
            )
          ),
        },
      })
      if (results.plan_json.globalSettings) {
        dispatch({
          type: TYPES.LOAD_GLOBAL_SETTINGS,
          payload: { globalSettings: results.plan_json.globalSettings },
        })
      }
      if (results.plan_json.share_id) {
        dispatch({
          type: TYPES.SET_SHARE_ID,
          payload: {
            value: results.plan_json.share_id,
          },
        })
      }
    })
}

export const loadDraftPlan = id => dispatch => {
  fetch(`https://backoffice.capitalmind.in/api/goals/plans/json/draft/${id}`, {
    credentials: 'include',
  })
    .then(response => {
      if (response.ok) {
        return response.json()
      } else {
        throw Error('Failed to fetch data')
      }
    })
    .then(({ results: { plan_json: { profile, goals, globalSettings } } }) => {
      dispatch({
        type: TYPES.DELETE_ALL_GOALS,
      })
      dispatch({
        type: TYPES.LOAD_PROFILE,
        payload: { profile: makeProfileCompatible(profile) },
      })
      dispatch({
        type: TYPES.LOAD_GOALS,
        payload: { goals: makeGoalsCompatible(goals) },
      })
      if (globalSettings) {
        dispatch({
          type: TYPES.LOAD_GLOBAL_SETTINGS,
          payload: { globalSettings },
        })
      }
    })
}

export const toggleMobileMenu = () => ({
  type: TYPES.TOGGLE_MOBILE_MENU,
})



// WEBPACK FOOTER //
// ./src/store/actions.js